import { http } from '@/lib/ats-https';

const getScoreCardTemplates = async (queryParam) => {
  const response = await http.get(
    `ats_scorecards/list_templates?${queryParam}`
  );
  return response.data?.ats_scorecards;
};

export const API_SERVICE = {
  getScoreCardTemplates,
};
